export const instrumentationEventTypes = {
    PanelAction: "panelaction",
    PanelView: "panelview",
    Performance: "perf",
    Session: "session",
    Custom: "custom",
    Viewed: "Viewed"
};
